import React from 'react';
import { FormControl, FormLabel, TextField, FormHelperText } from '@mui/material';
import useStyles from '../useStyles';
import PropTypes from 'prop-types';

function TextAreaWithCounter({ title, value, setValue, maxLength, helperText }) {
  const classes = useStyles();

  return (
    <FormControl fullWidth className={`${classes.formControl} ${classes.medium}`}>
      <FormLabel className={classes.label}>{title}</FormLabel>
      <TextField
        className={classes.textField}
        variant="outlined"
        value={value}
        onChange={(e) => e.target.value.length <= maxLength && setValue(e.target.value)}
      />
      <FormHelperText className={classes.helperText}>
        <span style={{ marginRight: '1rem' }}>{helperText}</span>
        {value ? value.length : 0} /{maxLength}
      </FormHelperText>
    </FormControl>
  );
}

TextAreaWithCounter.propTypes = {
  title: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  maxLength: PropTypes.number.isRequired,
  value: PropTypes.string,
  helperText: PropTypes.string
};

export default TextAreaWithCounter;
